import { render, staticRenderFns } from "./CargoDComponent.vue?vue&type=template&id=78fa3236&"
import script from "./CargoDComponent.vue?vue&type=script&lang=js&"
export * from "./CargoDComponent.vue?vue&type=script&lang=js&"
import style0 from "./CargoDComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports